import React from 'react';
import Table from 'components/ui-kits/Table';
import CardInvoicesList from './CardInvoicesList';
import { InvoicesTableWrapper, NotDataYet } from './InvoicesTable.style';
import { DownloadIcon } from 'components/ui-kits/Icon';
import Loader from 'components/Loader';
import { useMutation } from 'react-query';
import {
  downLoadFileNameInvoices,
  downLoadPdfFile,
  getInvoiceType,
  renderTypeString
} from 'utils';
import { invoicesDownloadPDFV3 } from 'services/invoicesService';
import type { Invoice } from 'types/InvoicesList';

interface Iprops {
  onData?: {
    invoices: Invoice[];
  };
}

const headerTable = [
  { label: 'Numéro de Facture' },
  { label: 'Type' },
  { label: 'Date' },
  { label: 'Télécharger le PDF' }
];

const notDataText = "Vous n'avez pas encore de commandes avec factures.";

const InvoicesTable = ({ onData }: Iprops) => {
  const listInvoices = onData?.invoices;
  const { isLoading, mutate } = useMutation(invoicesDownloadPDFV3, {
    onSuccess: (blob: any, data: any) => {
      downLoadPdfFile(
        blob,
        downLoadFileNameInvoices(data?.invoiceType, data?.id)
      );
    }
  });

  const handleDownloadPDF = (e: any) => {
    const invoiceType = getInvoiceType(e.getAttribute('data-type')) || '';
    const id = e.getAttribute('data-id') || '';
    mutate({ invoiceType, id });
  };

  return (
    <InvoicesTableWrapper>
      <Table header={headerTable}>
        {listInvoices && listInvoices.length > 0 ? (
          listInvoices.map((invoice) => {
            return (
              <CardInvoicesList
                key={invoice.id}
                id={invoice.id}
                invoicesNumber={invoice.number}
                type={renderTypeString(invoice.type)}
                createdAt={invoice.createdAt}
                downloadPdf={
                  <DownloadIcon
                    data-id={invoice.id}
                    data-type={invoice.type}
                    onClick={(e) => {
                      handleDownloadPDF(e.currentTarget);
                    }}
                  />
                }
              />
            );
          })
        ) : (
          <tr>
            <NotDataYet colSpan={4}>{notDataText}</NotDataYet>
          </tr>
        )}
      </Table>
      {isLoading && <Loader />}
    </InvoicesTableWrapper>
  );
};

export default InvoicesTable;
